var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.807,
    height: 29.001,
    viewBox: "0 0 32.807 29.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.407 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.823,150.569a3.641,3.641,0,1,0,3.641,3.641A3.645,3.645,0,0,0,152.823,150.569Zm0,5.825a2.184,2.184,0,1,1,2.184-2.184A2.187,2.187,0,0,1,152.823,156.394Z",
    transform: "translate(-130.16 -140.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.844,7.757l-2.07-.334,1.238-1.646a.729.729,0,0,0-.063-.95l-2.069-2.1a.726.726,0,0,0-.955-.072L11.233,3.847l-.328-2.039a.728.728,0,0,0-.719-.612H7.274a.728.728,0,0,0-.721.625L6.213,3.884,4.53,2.654a.727.727,0,0,0-.944.072L1.525,4.779a.728.728,0,0,0-.068.954L2.664,7.422.625,7.713A.728.728,0,0,0,0,8.434v2.913a.725.725,0,0,0,.625.719l2.07.334L1.457,14.045A.728.728,0,0,0,1.524,15l2.061,2.061a.727.727,0,0,0,.953.067l1.688-1.207.291,2.039a.728.728,0,0,0,.721.625H10.15a.727.727,0,0,0,.721-.623l.334-2.07,1.646,1.238a.727.727,0,0,0,.953-.067L15.864,15a.728.728,0,0,0,.067-.953l-1.225-1.686,2.119-.248a.727.727,0,0,0,.644-.723V8.478A.728.728,0,0,0,16.844,7.757Zm-.831,2.985-1.486.173a1.429,1.429,0,0,0-1.161.9,1.462,1.462,0,0,0,.165,1.461l.858,1.14-1.166,1.166-1.145-.861a1.433,1.433,0,0,0-1.41-.179,1.449,1.449,0,0,0-.946,1.171l-.2,1.413H7.87l-.2-1.4a1.428,1.428,0,0,0-.9-1.161,1.463,1.463,0,0,0-1.461.165l-1.14.858L3,14.417l.861-1.145a1.435,1.435,0,0,0,.179-1.41,1.449,1.449,0,0,0-1.172-.946l-1.413-.2V9.065l1.405-.2a1.428,1.428,0,0,0,1.161-.9A1.464,1.464,0,0,0,3.858,6.5L3,5.363,4.172,4.2l1.177.861A1.5,1.5,0,0,0,7.7,4.066l.2-1.414H9.566l.226,1.4a1.429,1.429,0,0,0,.9,1.164,1.463,1.463,0,0,0,1.458-.164l1.137-.85,1.183,1.2-.864,1.148A1.5,1.5,0,0,0,14.6,8.907l1.413.2v1.633Z",
    transform: "translate(13.932 3.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 29,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.129v5",
    transform: "translate(0 1.129)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,11,9",
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13V0",
    transform: "translate(11 14)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 4,
    transform: "translate(11 25)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2,
    transform: "translate(29 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemFilter);
export default __webpack_public_path__ + "static/media/system_filter.d92298539132364b2bc8567d23d4951d.svg";
export { ForwardRef as ReactComponent };